import {
    ChangeDetectionStrategy,
    Component,
    HostBinding,
    Input,
    ViewEncapsulation
} from '@angular/core';
import { EnumLike } from '@sona/shared-model-common';

import { ICON_CLASSES, IconAppearance } from './models/icon-appearance';
import { IconSize } from './models/icon-size';

/**
 * This component can be used to display an icon.
 */
@Component({
    selector: 'sona-icon',
    imports: [],
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'c-sona-icon'
    }
})
export class SonaIconComponent {
    /**
     * Sets the appearance of an icon.
     */
    @Input()
    appearance: EnumLike<IconAppearance> = IconAppearance.REGULAR;

    /**
     * Sets the specific name of an icon.
     * Example: 'rocket-launch', 'planet'
     *
     * @see https://phosphoricons.com/
     */
    @Input()
    name?: string;

    /**
     * Sets the size, the visual dimension of an icon.
     */
    @Input()
    @HostBinding('attr.size')
    size: EnumLike<IconSize> = IconSize.MEDIUM;

    /**
     * Maps the icon class to the internal appearance naming.
     */
    get _iconClass() {
        return ICON_CLASSES[this.appearance];
    }
}
